import React from "react";
import { Link } from "gatsby";
import { ReactComponent as Arrow } from "../icons/arrow-right.svg";

interface ButtonProps {
  children: React.ReactNode;
  color: "blue" | "green" | "rose" | "brown" | null;
  className?: string;
  link?: string;
  ariaLabel?: string;
}

const isExternal = (href?: string) =>
  href?.startsWith("http://") || href?.startsWith("https://");

export const ButtonPrimary = ({
  children,
  color,
  className = "",
  link,
  ariaLabel,
}: ButtonProps) => {
  const baseClass = `w-[265px] !h-[60px] [&>p]:!m-0 !font-secondary [&>p]:!font-secondary [&>p]:!font-normal [&>p]:!text-white transition-all text-lg py-2 px-4 rounded-lg ${className}`;

  const colorClass = {
    blue: "border-2 border-blueLight bg-white !text-blueLight hover:!text-white hover:border-blueLight hover:bg-blueLight",
    green: "border-2 border-greenLight bg-greenLight !text-greenWhite hover:border-greenDark hover:bg-greenDark",
    rose: "bg-roseExtraLight !text-white hover:bg-roseDark",
    brown: "bg-roseExtraLight !text-white hover:bg-brownLight",
  }[color ?? "blue"];

  const finalClass = `${baseClass} ${colorClass}`;

  if (!link) {
    return (
      <button className={finalClass} aria-label={ariaLabel ?? undefined}>
        {children}
      </button>
    );
  }

  if (isExternal(link)) {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className={`${finalClass} flex items-center`}
        aria-label={ariaLabel ?? undefined}
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={link} className={finalClass} aria-label={ariaLabel ?? undefined}>
      {children}
    </Link>
  );
};

export const ButtonSecondary = ({
  color,
  children,
  className = "",
  link,
  ariaLabel,
}: ButtonProps) => {
  const baseClass = `max-w-max relative !group flex items-center text-black ${className}`;

  const content = (
    <>
      {children}
    </>
  );

  if (!link) {
    return (
      <button className={baseClass} aria-label={ariaLabel ?? undefined}>
        {content}
      </button>
    );
  }

  if (isExternal(link)) {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className={baseClass}
        aria-label={ariaLabel ?? undefined}
      >
        {content}
      </a>
    );
  }

  return (
    <Link to={link} className={baseClass} aria-label={ariaLabel ?? undefined}>
      {content}
    </Link>
  );
};
